import type { SymbolDefinition } from "../types.ts";

export const earth: SymbolDefinition = {
  id: "ep-earth",
  familyKey: "earth",
  deviceKind: "earth",
  version: "0.1.0",
  label: { sv: "Jord", en: "Earth" },
  description: { sv: "Skyddsjord.", en: "Protective earth." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <line x1="12" y1="2" x2="12" y2="10"/>
      <line x1="6" y1="10" x2="18" y2="10"/>
      <line x1="8" y1="14" x2="16" y2="14"/>
      <line x1="10" y1="18" x2="14" y2="18"/>
    </g>
  `,
  terminals: [{ id: "PE", kind: "earth", label: "PE", position: "top", offset: 0.5 }],
  designationPrefix: "PE",
  searchKeywords: ["jord", "earth", "skyddsjord", "PE"],
};
